import { render, staticRenderFns } from "./CoursePremium.vue?vue&type=template&id=4e2c5c26"
import script from "./CoursePremium.vue?vue&type=script&lang=js"
export * from "./CoursePremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports